import React from "react";
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App.jsx'
import CantiqueContext from './Context/CantiqueContext';
import { AuthProvider } from './Context/AuthContext';
import { ThemeProvider } from './Context/ThemeContext';
import './style/main.scss' 

// Offline shell. Production only: in development it would cache the dev bundles.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).catch((err) => {
      console.error('service worker', err);
    });
    navigator.serviceWorker.ready.then((registration) => {
      const urls = performance.getEntriesByType('resource')
        .map((entry) => entry.name)
        .filter((name) => /\.(js|css|png|jpe?g|svg|webp|woff2?|ttf)(\?|$)|fonts\.googleapis\.com/.test(name));
      registration.active?.postMessage({ type: 'CACHE_URLS', urls });
    });
  });
}


ReactDOM.createRoot(document.getElementById('root'))
.render(
  <Router>
    <ThemeProvider>
      <AuthProvider>
        <CantiqueContext>
          <App />
        </CantiqueContext>
      </AuthProvider>
    </ThemeProvider>
  </Router>
)